import React from 'react';

function GeneralHeader({ page, title, subtitle }) {
  return (
    <header className='grid lg:justify-center px-4 sm:px-16 md:px-24 pt-4 lg:pt-48 z-10'>
      <div
        className='grid shadow-md rounded-lg curved_box lg:container lg:mx-auto
             bg-black/30 h-fit p-1.5 overflow-hidden lg:max-w-[60vw]'
      >
        <div className='grid p-0.5 rounded-lg bg-colour3 curved_box'>
          <article className='grid bg-colour2 rounded-lg curved_box h-fit pt-8 overflow-hidden'>
            <div className='grid gap-4 lg:gap-6 w-full h-fit text-center'>
              <div className='px-2 sm:px-3 md:px-6 lg:pt-2'>
                <h1 className='font-titleFont text-3xl lg:text-4xl xl:text-5xl text-colour3 underline underline-offset-8 text_shadow'>
                  {page}
                </h1>
              </div>
              <div className='grid bg-black/80 w-full px-4 sm:px-6 lg:px-16 xl:px-32 py-6 sm:py-5 md:py-6 gap-y-2 lg:gap-y-0'>
                <h2 className='font-titleFont font-semibold text-sm lg:text-xl text-colour5'>
                  {title}
                </h2>
                {subtitle && (
                  <h3 className='font-titleFont font-semibold text-sm lg:text-lg text-colour5'>
                    {subtitle}
                  </h3>
                )}
              </div>
            </div>
          </article>
        </div>
      </div>
    </header>
  );
}

export default GeneralHeader;
